import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import styled from "styled-components";
import useOnClickOutside from "use-onclickoutside";

const Wrapper = styled.ul`
  padding: 3px 0;
  z-index: 5;
  position: absolute;
  top: 35px;
  right: -11px;
  background-color: white;
  border: 2px solid #f1f1f1;
  border-radius: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
  list-style-type: none;
  white-space: nowrap;

  &::before {
    content: "";
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: -8px;
    right: 14px;
    border-bottom: 8px solid #fff;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    z-index: 1;
  }

  &::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: -10px;
    right: 12px;
    border-bottom: 10px solid #f1f1f1;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
`;

const Item = styled.li`
  padding: 5px 10px;
  font-weight: normal;
  color: #000;
  font-size: 14px;

  &:hover {
    background-color: #f1f1f1;
  }
`;

const SettingsDropDown = (props) => {
  const {
    intl,
    setOpen,
    setHoverDelete,
    id,
    remove,
    add,
    parentId,
    moveRowStart,
    copy,
  } = props;

  const ref = useRef();
  useOnClickOutside(ref, () => setOpen(false));

  return (
    <Wrapper ref={ref}>
      <Item
        data-name="Row"
        data-type="sibling"
        data-parentid={id}
        onClick={add}
      >
        {intl.formatMessage({ id: "Row.option.add" })}
      </Item>
      <Item onClick={() => moveRowStart({ id, isRow: true })}>
        {intl.formatMessage({ id: "Row.option.move" })}
      </Item>
      <Item onClick={() => copy({ id, isRow: true })}>Kopiera rad</Item>
      <Item
        data-id={id}
        data-parentid={parentId}
        onMouseEnter={() => setHoverDelete(true)}
        onMouseLeave={() => setHoverDelete(false)}
        onClick={remove}
      >
        {intl.formatMessage({ id: "Row.option.delete" })}
      </Item>
    </Wrapper>
  );
};

export default injectIntl(SettingsDropDown);
